import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import SocialLinkRowItemLazy from './SocialLinkRowItemLazy';
import AppStoreLinkLazy from '../AppStoreLink/AppStoreLinkLazy';
import { SocialLinkRowItemProps } from './SocialLinkRowItem';
import { SocialLinkRow_viewer } from './__generated__/SocialLinkRow_viewer.graphql';
import classnames from 'classnames';

import style from './SocialLinkRow-style.scss';

type Props = {
    items: SocialLinkRowItemProps[];
    isClient: boolean;
    isMobile: boolean;
    viewer: SocialLinkRow_viewer;
};
export const SocialLinkRowComponent: FC<Props> = ({ isMobile, items, viewer = {}, isClient }) =>
    isClient ? (
        <ul className={classnames(style.row, { [style.isMobile]: isMobile })}>
            {items.map(item => (
                <React.Suspense fallback={''} key={item.name}>
                    <SocialLinkRowItemLazy {...item} />
                </React.Suspense>
            ))}
            {!isMobile && viewer.isDownloadAppEnabled && (
                <li>
                    <AppStoreLinkLazy />
                </li>
            )}
        </ul>
    ) : null;

const mapStateToProps = ({ header }: { header: { isMobile: boolean } }): { isMobile: boolean } => ({
    isMobile: header.isMobile,
});

export const SocialLinkRow = createFragmentContainer(
    connect(mapStateToProps)(SocialLinkRowComponent),
    {
        viewer: graphql`
            fragment SocialLinkRow_viewer on Viewer {
                isDownloadAppEnabled: isEnabledByLocale(featureName: "DOWNLOAD_APP")
            }
        `,
    }
);
